// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';

const THEME_STORAGE_KEY = 'navType';

const readInitialNavType = () => {
    try {
        const stored = typeof window !== 'undefined' && window.localStorage
            ? window.localStorage.getItem(THEME_STORAGE_KEY)
            : null;
        return stored === 'dark' ? 'dark' : 'light';
    } catch {
        return 'light';
    }
};

export const initialState = {
    isOpen: [], // for active default menu
    defaultId: 'default',
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    opened: true,
    navType: readInitialNavType(),
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            id = action.id;
            return {
                ...state,
                isOpen: [id]
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.opened
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius
            };
        case actionTypes.SET_THEME: {
            const navType = action.navType === 'dark' ? 'dark' : 'light';
            try {
                if (typeof window !== 'undefined' && window.localStorage) {
                    window.localStorage.setItem(THEME_STORAGE_KEY, navType);
                }
            } catch {
                // ignore (private browsing / disabled storage)
            }
            return { ...state, navType };
        }
        default:
            return state;
    }
};

export default customizationReducer;
